import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://qvwoclhzryzxdcyuwidw.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF2d29jbGh6cnl6eGRjeXV3aWR3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDQ3MjY3NjAsImV4cCI6MjAyMDMwMjc2MH0.y2J_uR7Dxm39R2o1SuiGygZvPQZP3FEydADTBTuXz04",
)
